'use client';
import styled from 'styled-components';
import { StyledImage } from '@web/atoms/ImageCard/styles';

export const Wrapper = styled.div``;

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  width: 100vw;
  padding-bottom: ${props => props.theme.spacing(25)};

  @media ${props => props.theme.tabletL} {
    display: flex;
    padding-bottom: ${props => props.theme.spacing(0)};
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;

  @media ${props => props.theme.tabletL} {
    display: flex;
    position: relative;
    height: 100%;
    width: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 85vh !important;
      object-fit: cover;
    }
  }
`;

export const MobileImageContainer = styled.div`
  overflow: hidden;
  border-radius: 24px;
  aspect-ratio: 345/162;
  position: relative;
  img {
    transform: translateY(-15px);
  }

  @media ${props => props.theme.tabletL} {
    display: none;
  }
`;

export const DesktopPillContainer = styled.div`
  display: none;

  @media ${props => props.theme.tabletL} {
    display: block;
  }
`;

export const MobilePillContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-50%, 50%);
  z-index: 1;
`;

export const FormContainer = styled.div`
  padding: ${props => props.theme.spacing(6, 5, 0)};
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: ${props => (props.$maxWidth ? `${props.$maxWidth}px` : 'none')};
  margin: auto;
  gap: ${props => props.theme.spacing(3)};

  ${StyledImage} {
    min-height: 85px;
    min-width: 85px;

    img {
      height: 61px;
      width: 61px;
    }
  }

  @media ${props => props.theme.tabletL} {
    gap: ${props => props.theme.spacing(3)};
    padding: ${props => props.theme.spacing(0, 0, 12)};
    justify-content: center;
    min-height: 85vh;
  }
`;

export const Heading = styled.h2`
  ${({ theme }) => theme.typography.heading2};
  color: ${props => props.theme.colors.text.primary};

  @media ${props => props.theme.tablet} {
    ${({ theme }) => theme.typography.heading3};
  }
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  color: #37332d;
  text-align: center;

  @media ${props => props.theme.tabletL} {
    width: 80%;
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 100%;
  fieldset {
    padding: 0;
  }
`;

export const ButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 17px;
  left: 12px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    border: none;
  }
  @media ${props => props.theme.tabletL} {
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;
